<div
    class="fixed bottom-5 z-[10000] flex flex-col gap-3 ltr:right-5 rtl:left-5"
    style="width: 22rem; max-width: calc(100vw - 2.5rem)"
>
    @for (toast of toasts; track trackByToastId($index, toast)) {
        <div
            animate.enter="toast-enter"
            animate.leave="toast-leave"
            (mouseenter)="onMouseEnter(toast)"
            (mouseleave)="onMouseLeave(toast)"
            class="relative overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black/5"
        >
            <!-- Left/Right color accent bar -->
            <div
                class="absolute inset-y-0 w-1 ltr:left-0 rtl:right-0"
                [ngClass]="{
                    'bg-emerald-500': toast.type === 'success',
                    'bg-sky-500': toast.type === 'info',
                    'bg-amber-500': toast.type === 'warning',
                    'bg-red-500': toast.type === 'error',
                }"
            ></div>
            <div class="flex items-start gap-3 p-4 ltr:pl-5 rtl:pr-5">
                <!-- Icon -->
                <div
                    class="mt-0.5 flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full"
                    [ngClass]="{
                        'bg-emerald-50 text-emerald-600':
                            toast.type === 'success',
                        'bg-sky-50 text-sky-600': toast.type === 'info',
                        'bg-amber-50 text-amber-600': toast.type === 'warning',
                        'bg-red-50 text-red-600': toast.type === 'error',
                    }"
                >
                    <i [class]="getIconClass(toast.type)" class="text-sm"></i>
                </div>
                <!-- Message -->
                <p class="flex-1 pt-0.5 text-sm leading-relaxed text-slate-700">
                    {{ toast.message }}
                </p>
                <!-- Close button -->
                <button
                    (click)="dismiss(toast)"
                    class="mt-0.5 flex-shrink-0 rounded p-0.5 text-slate-400 transition-colors hover:text-slate-600"
                >
                    <i class="fa-light fa-xmark text-xs"></i>
                </button>
            </div>
            <!-- Progress bar -->
            <div class="absolute bottom-0 left-0 right-0 h-0.5 bg-slate-100">
                <div
                    class="toast-progress h-full"
                    [ngClass]="{
                        'bg-emerald-400': toast.type === 'success',
                        'bg-sky-400': toast.type === 'info',
                        'bg-amber-400': toast.type === 'warning',
                        'bg-red-400': toast.type === 'error',
                    }"
                    [style.animation-duration.ms]="toast.duration"
                    [style.animation-play-state]="
                        toast.paused ? 'paused' : 'running'
                    "
                ></div>
            </div>
        </div>
    }
</div>
